import { ReactNode } from 'react';

interface FeatureButtonProps {
  icon: ReactNode;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

// Map long labels to short mobile versions
const getShortLabel = (label: string): string => {
  const labelMap: Record<string, string> = {
    'Bible References': 'Bible',
    'Doctrinal': 'Doctrine',
    'Format Export': 'Export',
    'Deep Research': 'Research',
  };
  return labelMap[label] || label;
};

export default function FeatureButton({ icon, label, isActive, onClick }: FeatureButtonProps) {
  const shortLabel = getShortLabel(label);

  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={isActive}
      aria-label={`${label} mode${isActive ? ' - active' : ''}`}
      className={`
        flex items-center gap-2 px-3 sm:px-4 py-2.5 sm:py-2 rounded-lg
        min-h-[44px] flex-shrink-0
        transition-all duration-200
        active:scale-95
        focus:outline-none focus:ring-2 focus:ring-accent-blue focus:ring-offset-2 focus:ring-offset-dark-bg
        ${isActive
          ? 'bg-gradient-to-r from-accent-blue to-accent-orange text-white'
          : 'bg-dark-card border border-dark-border text-dark-text-muted hover:border-accent-blue active:bg-dark-border'
        }
      `}
    >
      <span className="w-5 h-5">{icon}</span>
      <span className="text-xs sm:text-sm font-medium whitespace-nowrap">
        <span className="inline sm:hidden">{shortLabel}</span>
        <span className="hidden sm:inline">{label}</span>
      </span>
    </button>
  );
}
